// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__29pA_","horizontal":"styles_horizontal__1Gl7x","vertical":"styles_vertical__T_wGU"};